import React from "react";
import Cms from "../../features/cms/Cms";

export const CmsModule = () => {
  return (
    <>
      <Cms />
    </>
  );
};